<div class="modal-header w-100">
    <h1 id="title" class="font-weight-bold">
        {{ "SHIFT_SPLIT_TIME" | translate: {employeeName: employee.employeeName} }}</h1>
    <button type="button" class="close" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body h-100 pb-0">
    <app-spinner
        [overlay]="true"
        [overlayRounded]="true"
        [visible]="!employee || isLoading"
    ></app-spinner>
    @if (employee) {
        <div>
            <h2 class="font-weight-bold">
                {{ "SHIFT_TIME_FULL" | translate: {fromTime: employee.fromTime, toTime: employee.toTime} }}
            </h2>
            @if (showRequiredTaskWarning) {
                <div class="d-flex flex-row warning-text my-2">
                    <span class="vismaicon vismaicon-md vismaicon-filled vismaicon-warning my-auto mr-2"></span>
                    <div class="my-auto">
                        {{ "SPLIT_SHIFT_REQUIRED_TASKS_WARNING" | translate }}
                    </div>
                </div>
            }
            <form [formGroup]="shiftSplitForm">
                <div class="d-flex mb-4">
                    <label class="formLabel my-auto" for="split-from-time">
                        {{ "SPLIT_START_TIME" | translate }}
                    </label>
                    <app-time-picker
                        id="split-from-time"
                        formControlName="fromTime"
                        errorPosition="right"
                        [(ngModel)]="formEmployee.fromTime"
                        [ngClass]="{
                            'has-error':
                                !shiftSplitForm.pristine &&
                                (shiftSplitForm.controls['fromTime'].errors ||
                                (shiftSplitForm.errors && shiftSplitForm.errors.dateAndTimeGreaterThanOrEqual) ||
                                (shiftSplitForm.errors && shiftSplitForm.errors.timeOverlaps) ||
                                (shiftSplitForm.errors && shiftSplitForm.errors.windowExceeds) ||
                                (shiftSplitForm.errors && shiftSplitForm.errors.predefinedTasksExist))
                        }"
                        appCustomPopover
                        [popoverText]="!shiftSplitForm.pristine && getShiftSplitFormError(shiftSplitForm)"
                        popoverType="error"
                        placement="right"
                    >
                    </app-time-picker>
                </div>
                <div class="d-flex mb-4">
                    <label class="formLabel my-auto" for="split-to-time">
                        {{ "SPLIT_END_TIME" | translate }}
                    </label>
                    <app-time-picker
                        id="split-to-time"
                        formControlName="toTime"
                        [(ngModel)]="formEmployee.toTime"
                        [ngClass]="{
                            'has-error':
                                !shiftSplitForm.pristine &&
                                (shiftSplitForm.controls['toTime'].errors ||
                                (shiftSplitForm.errors && shiftSplitForm.errors.dateAndTimeGreaterThanOrEqual) ||
                                (shiftSplitForm.errors && shiftSplitForm.errors.timeOverlaps) ||
                                (shiftSplitForm.errors && shiftSplitForm.errors.windowExceeds) ||
                                (shiftSplitForm.errors && shiftSplitForm.errors.predefinedTasksExist))
                        }"
                        appCustomPopover
                        [popoverText]="!shiftSplitForm.pristine && getShiftSplitFormError(shiftSplitForm)"
                        popoverType="error"
                        placement="right"
                    >
                    </app-time-picker>
                </div>
                <div class="d-flex mb-4">
                    <label class="formLabel my-auto" for="split-task-name">
                        {{ "DESCRIPTION" | translate }}
                    </label>
                    <input
                        id="split-task-name"
                        class="w-100"
                        formControlName="taskName"
                        [ngClass]="{
                'has-error':
                    !shiftSplitForm.pristine &&
                    (shiftSplitForm.controls['taskName'].errors) }"
                    >
                </div>
                <div class="d-inline-flex justify-content-end w-100 pt-3">
                    <button class="btn admin-task-modal-btn btn-primary mr-4"
                            type="button"
                            translate="{{splitExists ? 'UPDATE' : 'SAVE'}}"
                            [disabled]="shiftSplitForm.errors || shiftSplitForm.invalid || shiftSplitForm.pristine"
                            (click)="splitConfirmClicked()"
                    >
                    </button>
                    <button class="btn admin-task-modal-btn btn-secondary"
                            type="button"
                            translate="CANCEL"
                            (click)="dismissModal()">
                    </button>
                </div>
            </form>
        </div>
    }
</div>
